import React, { Fragment } from 'react'
import { Button, Form } from 'react-bootstrap'
import { TextField } from '@material-ui/core'

export default class ResetPasswordForm extends React.PureComponent {
    // private formRef: React.RefObject<HTMLFormElement>
    // constructor(props) {
    //   super(props)
    //   this.formRef = React.createRef()
    // }

    validateForm = () =>
        // this.formRef.current!.checkValidity() &&
        this.getPasswordValidationText() === '' &&
        this.props.password1 === this.props.password2

    getPasswordValidationText() {
        if (this.props.password1 !== '') {
            if (this.props.password1.includes(' ')) {
                return 'Spaces cannot be used for password!'
            } else if (this.props.password1.length < 6) {
                return 'Please enter a password that is at least 6 chatacters long.'
            }
        }
        return ''
    }

    render() {
        return (
            <div>
                <small className='form-text text-muted'>
                    The password must be at least 6 characters in length. It will take
                    effect the next time the user logs in.
                </small>
                <Form
                    // ref={this.formRef}
                    className='needs-validation'
                    onSubmit={(e) => {
                        e.preventDefault()
                        if (this.validateForm()) {
                            this.props.onSubmit(e)
                        }
                    }}
                >
                    <div>
                        <TextField
                            value={this.props.password1}
                            name='password1'
                            onChange={(e) =>
                                this.props.onChange(e, true)
                            }
                            type='password'
                            id='newpwdFormPassword1'
                            label='New password'
                            error={
                                this.props.password1 !== '' &&
                                (this.props.password1.length < 6 ||
                                    this.props.password1.includes(' '))
                            }
                            helperText={this.getPasswordValidationText()}
                            required
                        />
                    </div>
                    <div>
                        <TextField
                            value={this.props.password2}
                            name='password2'
                            onChange={(e) =>
                                this.props.onChange(e, false)
                            }
                            type='password'
                            id='newpwdFormPassword2'
                            label='Confirm new password'
                            error={
                                this.props.password2 !== '' &&
                                this.props.password1 !== this.props.password2
                            }
                            helperText={
                                this.props.password2 !== '' &&
                                    this.props.password1 !== this.props.password2
                                    ? 'Passwords do not match'
                                    : ''
                            }
                            required
                        />
                    </div>
                    {this.props.formError ? (
                        <div className='errorMsg'>{this.props.formError}</div>
                    ) : (
                        <Fragment />
                    )}
                    <Button
                        color='light'
                        type='submit'
                        size='sm'
                        className='float-right mr-0'
                    >
                        Save
                    </Button>
                </Form>
            </div>
        )
    }
}